import React from "react";
import { useSite } from "@/context/SiteContext";

export default function WhatsAppButton() {
  const { settings } = useSite();
  const href = `https://wa.me/${settings.whatsapp}?text=${encodeURIComponent("Hi Adam's! I'd love to know more about your collection.")}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float-button"
      className="fixed bottom-[calc(88px+env(safe-area-inset-bottom))] lg:bottom-6 right-4 lg:right-6 z-40 flex items-center gap-2 bg-[#25D366] text-white pl-3 pr-4 py-3 rounded-full shadow-[0_8px_30px_-6px_rgba(37,211,102,0.6)] hover:scale-105 transition-transform duration-300 group"
      aria-label="Chat on WhatsApp"
    >
      <svg viewBox="0 0 32 32" className="w-6 h-6 fill-white" aria-hidden>
        <path d="M16 3C9.4 3 4 8.4 4 15c0 2.1.6 4.1 1.6 5.9L4 29l8.3-1.6c1.7.9 3.7 1.4 5.7 1.4 6.6 0 12-5.4 12-12S22.6 3 16 3zm0 21.8c-1.8 0-3.5-.5-5-1.4l-.4-.2-3.7.7.7-3.6-.2-.4c-1-1.6-1.5-3.4-1.5-5.3 0-5.4 4.4-9.8 9.8-9.8s9.8 4.4 9.8 9.8-4.4 9.8-9.8 9.8zm5.4-7.3c-.3-.1-1.8-.9-2-1-.3-.1-.5-.1-.7.1-.2.3-.7.9-.9 1.1-.2.2-.3.2-.6.1-1.8-.9-2.9-1.6-4.1-3.6-.3-.5.3-.5.8-1.6.1-.2 0-.4 0-.5-.1-.1-.7-1.6-.9-2.2-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.5s1.1 2.9 1.2 3.1c.2.2 2.1 3.2 5.1 4.5.7.3 1.3.5 1.7.6.7.2 1.4.2 1.9.1.6-.1 1.8-.7 2-1.4.3-.7.3-1.3.2-1.4-.1-.1-.3-.2-.6-.4z"/>
      </svg>
      <span className="hidden lg:inline text-sm font-medium font-sans max-w-0 group-hover:max-w-[140px] overflow-hidden whitespace-nowrap transition-all duration-500">Chat with us</span>
    </a>
  );
}
